export const GET = "GET";
export const GET_LIST = "GET_LIST";
export const SET = "SET";
export const SET_LIST = "SET_LIST";
export const DELETE = "DELETE";
export const UPDATE = "UPDATE";
export const RESET_STATE = "RESET_STATE";
